import { render } from "./AddMultipleVotingsModal.vue?vue&type=template&id=73073af1&scoped=true"
import script from "./AddMultipleVotingsModal.vue?vue&type=script&lang=js"
export * from "./AddMultipleVotingsModal.vue?vue&type=script&lang=js"

import "./AddMultipleVotingsModal.vue?vue&type=style&index=0&id=73073af1&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73073af1"]])

export default __exports__